module.exports = __webpack_public_path__ + "media/Video 28.f3894ae7.mp4";